import Axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import constants from "../../constants/constants.json";
import Message from "../../helper/Message";
import { Table } from "antd";
import moment from "moment";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  SearchOutlined,
} from "@ant-design/icons";

import Highlighter from "react-highlight-words";
import Search from "./Search/Search";

export default function Invoices(props) {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <Search
        setSearchText={setSearchText}
        setSelectedKeys={setSelectedKeys}
        selectedKeys={selectedKeys}
        confirm={confirm}
        clearFilters={clearFilters}
        close={close}
        searchInput={searchInput}
        handleSearch={handleSearch}
        handleReset={handleReset}
        dataIndex={dataIndex}
        setSearchedColumn={setSearchedColumn}
      />
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1677ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: "name",
      dataIndex: "userName",
      key: "userName",
      ...getColumnSearchProps("userName"),
    },
    {
      title: "email",
      dataIndex: "userMail",
      key: "userMail",
      ...getColumnSearchProps("userMail"),
    },
    {
      title: "planName",
      dataIndex: "planName",
      key: "planName",
      ...getColumnSearchProps("planName"),
    },
    {
      title: "createTime",
      dataIndex: "invoiceCreateTime",
      key: "invoiceCreateTime",
      render: (status, record) => {
        return (
          <spann>
            {moment(record.invoiceCreateTime, "X").format(
              "YYYY-MM-DD hh:mm:ss"
            )}
          </spann>
        );
      },
    },
    {
      title: "expireTime",
      dataIndex: "invoiceExpireTime",
      key: "invoiceExpireTime",
      render: (status, record) => {
        return (
          <spann>
            {moment(record.invoiceExpireTime, "X").format(
              "YYYY-MM-DD hh:mm:ss"
            )}
          </spann>
        );
      },
    },

    {
      title: "",
      dataIndex: "status",
      key: "status",
      render: (status, record) => {
        return record.invoiceExpireTime >= moment().format("X") ? (
          <CheckCircleOutlined style={{ color: "green", fontSize: "18px" }} />
        ) : (
          <CloseCircleOutlined style={{ color: "red", fontSize: "18px" }} />
        );
      },
    },
  ];

  const fetchInvoices = async () => {
    try {
      setLoading(true);
      const res = await Axios.get(constants.url + "/admin/invoices", {
        headers: {
          authorization: "Bearer " + localStorage.getItem("pnsToken"),
        },
      });
      if (res.data.status === 202) {
        setInvoices(res.data.result.invoices);
      } else {
        Message.warning(res.data.result.message);
      }
      setLoading(false);
    } catch (error) {
      Message.error("Communication error");
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchInvoices();
  }, []);

  return (
    <Table
      loading={loading}
      dataSource={invoices}
      columns={columns}
      pagination={false}
    />
  );
}
